import { getInstance, injectableMap } from "./container";

import type { ClassConstructor } from "./container";

const SINGLETON_KEY: unique symbol = Symbol("__di_singleton_key__");

/**
 * 新版（TS5+ stage3）装饰器版 Provide
 * 零 any，不修改 tsconfig
 */
export function Provide<T extends object>(cls: ClassConstructor<T>) {
  return function (
    _value: undefined,
    context: ClassFieldDecoratorContext,
  ): void {
    const meta = injectableMap.get(cls as ClassConstructor<object>);
    const isSingleton = meta?.scope === "singleton";

    // 每个实例独立缓存（瞬态用）
    const instanceCache = new WeakMap<object, T>();
    // 单例缓存
    const singletonStore: Record<typeof SINGLETON_KEY, T | undefined> = {
      [SINGLETON_KEY]: undefined,
    };

    // 注册初始化逻辑：在实例创建后执行
    context.addInitializer(function (this: unknown): void {
      Object.defineProperty(this, context.name, {
        configurable: true,
        enumerable: true,
        get: (): T => {
          if (isSingleton) {
            if (singletonStore[SINGLETON_KEY] === undefined) {
              singletonStore[SINGLETON_KEY] = getInstance(cls);
            }
            return singletonStore[SINGLETON_KEY] as T;
          }

          let instance = instanceCache.get(this as object);
          if (instance === undefined) {
            instance = getInstance(cls);
            instanceCache.set(this as object, instance);
          }
          return instance;
        },
      });
    });
  };
}
